import { Box, Typography } from '@mui/material';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ReduxStore } from 'types/redux';

type Props = {
    firstName: string;
    lastName: string;
    roomNumber: string;
};

export const ResidentDetails = (props: Props) => {
    const { firstName, lastName, roomNumber } = props;

    const { room: roomTxt } = useSelector(
        (state: ReduxStore) => state.language.dictionary.home
    );

    return (
        <Box
            sx={{
                flexGrow: 1,
            }}
        >
            <Typography
                sx={{
                    textAlign: 'left',
                    fontWeight: 700,
                }}
            >
                {`${firstName} ${lastName}`}
            </Typography>
            <Typography
                sx={{
                    color: 'orange.main',
                    fontWeight: 700,
                }}
            >
                {`${roomTxt} ${roomNumber}`}
            </Typography>
        </Box>
    );
};
